"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Buttons_1 = require("../../Buttons");
var Icons_1 = require("../../Icons");
var Localization_1 = require("../../Localization");
var MediumModal_1 = require("../MediumModal");
var FrameworkMessagesList_1 = require("./components/FrameworkMessagesList");
var FrameworkMessagesPopup_styles_1 = require("./FrameworkMessagesPopup.styles");
exports.default = (function (_a) {
    var PopupHeaderText = _a.PopupHeaderText, OnCloseRequest = _a.OnCloseRequest, Messages = _a.Messages, OnComplete = _a.OnComplete;
    var buildMessages = function () {
        if (!Messages.some((function (x) { return x.Type === "Blocking"; }))) {
            return { messageResponses: Messages.map(function (m) { return (__assign(__assign({}, m), { Response: undefined })); }), hasBlockingErrors: false };
        }
        // If there are blocking errors then return only those
        var responses = Messages.reduce(function (result, option) {
            if (option.Type === "Blocking") {
                return result.concat(__assign(__assign({}, option), { Response: undefined }));
            }
            return result;
        }, []);
        return { messageResponses: responses, hasBlockingErrors: true };
    };
    var _b = React.useState(buildMessages()), state = _b[0], setState = _b[1];
    var _c = React.useState(false), showValidation = _c[0], setShowValidation = _c[1];
    var handleUpdateItem = function (ruleName, response) {
        var updatedItems = state.messageResponses.map(function (item) {
            return (item.RuleName === ruleName ? __assign(__assign({}, item), { Response: response }) : item);
        });
        setState(__assign(__assign({}, state), { messageResponses: updatedItems }));
        setShowValidation(false);
    };
    var handleOkClicked = function () {
        if (state.messageResponses.filter(function (f) { return f.Type !== "InformationDataError"; }).some(function (x) { return !x.Response; })) {
            setShowValidation(true);
            return;
        }
        OnComplete(state.messageResponses);
    };
    return (React.createElement(MediumModal_1.MediumModal, { Header: PopupHeaderText, ListenToBackgroundClick: false, OnCloseRequest: OnCloseRequest, RenderFooter: function () { return (React.createElement(FrameworkMessagesPopup_styles_1.FooterDiv, null,
            !state.hasBlockingErrors &&
                React.createElement(Buttons_1.PrimaryButton, { Caption: Localization_1.strings.FrameworkMessagesPopup_Action_Ok, OnClick: handleOkClicked }),
            React.createElement(Buttons_1.SecondaryButton, { Caption: Localization_1.strings.FrameworkMessagesPopup_Action_Cancel, OnClick: OnCloseRequest }))); } },
        React.createElement(FrameworkMessagesPopup_styles_1.ContainerDiv, null,
            React.createElement(FrameworkMessagesPopup_styles_1.BannerDiv, null,
                React.createElement(FrameworkMessagesPopup_styles_1.BannerContentDiv, null,
                    React.createElement(Icons_1.AlertIcon, null),
                    React.createElement(FrameworkMessagesPopup_styles_1.H2, null, Localization_1.strings.FrameworkMessagesPopup_Message_InstructionsTitle)),
                React.createElement(FrameworkMessagesPopup_styles_1.BannerDetailP, null, Localization_1.strings.FrameworkMessagesPopup_Message_InstructionsDetail)),
            React.createElement(FrameworkMessagesList_1.default, { MessageResponses: state.messageResponses, OnUpdateItem: handleUpdateItem }),
            showValidation &&
                React.createElement(FrameworkMessagesPopup_styles_1.ValidationStickyDiv, null,
                    React.createElement(FrameworkMessagesPopup_styles_1.P, { "aria-live": "assertive", role: "alert" }, Localization_1.strings.FrameworkMessagesPopup_Message_ValidationErrors)))));
});
